import { SET_LOCALE } from "@/constants/locale";

export const localeSet = (locale) => ({
  type: SET_LOCALE,
  locale,
});

export const setLocale = (locale) => (dispatch) => {
  localStorage.lang = locale;
  dispatch(localeSet(locale));
};